import React from 'react';
import { observer } from 'mobx-react';

import Section from '../uic/Section';
import { List, Row, Label, Value } from '../uic/list';

import VersionsModel from '../models/VersionsModel';

class VersionsSection extends React.Component {
    componentWillMount() {
        const { session } = this.props.session;
        this.model = new VersionsModel(session);
        this.model.load();
    }

    render() {
        const modelVer = this.model;

        return (
            <Section title="Versions">
                <List>
                    <Row>
                        <Label>Audiostream Version</Label>
                        <Value>{modelVer.audiostreamerversion}</Value>
                    </Row>
                    <Row>
                        <Label>Backend Version</Label>
                        <Value>{modelVer.backendversion}</Value>
                    </Row>
                    <Row>
                        <Label>Bootloader Version</Label>
                        <Value>{modelVer.bootloaderversion}</Value>
                    </Row>
                    <Row>
                        <Label>Firmware Version</Label>
                        <Value>{modelVer.firmwareversion}</Value>
                    </Row>
                    <Row>
                        <Label>Icecast Version</Label>
                        <Value>{modelVer.icecastversion}</Value>
                    </Row>
                    <Row>
                        <Label>Kernel Version</Label>
                        <Value style={{ fontSize: 12 }}>
                            {modelVer.kernelversion}
                        </Value>
                    </Row>
                    <Row>
                        <Label>Root-FS Version</Label>
                        <Value style={{ fontSize: 12 }}>
                            {modelVer.rootfsversion}
                        </Value>
                    </Row>
                    <Row>
                        <Label>Frontend Version</Label>
                        <Value>{modelVer.frontendversion}</Value>
                    </Row>
                    <Row>
                        <Label>React JS Version</Label>
                        <Value>{React.version}</Value>
                    </Row>
                </List>
            </Section>
        );
    }
}

export default observer(VersionsSection);



// WEBPACK FOOTER //
// ./src/sections/Versions.js